export default "__VITE_ASSET__CxXbgM11__"